import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProjectQuota, BackendQueryProjectQuotaArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectQuota($projectId: ID!) {
    projectQuota(projectId: $projectId) {
      exceedLimit
    }
  }
`;

type Variables = BackendQueryProjectQuotaArgs;
type Result = Pick<BackendProjectQuota, 'exceedLimit'>;

export const queryProjectQuota = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
